import React, { useState } from 'react';
import { Popover, Text, Box } from '@wix/design-system';
export const WithDisabledControl = _ref => {
  let {
    children,
    isDisabled,
    onEnable,
    t,
    placement = 'top',
    rootElementStyle
  } = _ref;
  const [isPopoverShown, setIsPopoverShown] = useState(false);
  const handleHoverIn = () => {
    if (isDisabled) {
      setIsPopoverShown(true);
    }
  };
  const handleHoverOut = () => {
    if (isDisabled) {
      setIsPopoverShown(false);
    }
  };
  const handleClick = () => {
    if (isDisabled) {
      onEnable();
      setIsPopoverShown(false);
    }
  };
  return /*#__PURE__*/React.createElement(Popover, {
    shown: isPopoverShown,
    appendTo: "window",
    placement: placement,
    animate: true,
    moveBy: {
      y: 5
    },
    style: rootElementStyle,
    zIndex: 99999
  }, /*#__PURE__*/React.createElement(Popover.Element, null, /*#__PURE__*/React.createElement("div", {
    onMouseEnter: handleHoverIn,
    onMouseLeave: handleHoverOut,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      pointerEvents: isDisabled ? 'none' : 'auto'
    }
  }, children))), /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(Box, {
    padding: "8px 12px",
    width: "145"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, t('Shared.DisabledWidgetControl.tooltip')))));
};
//# sourceMappingURL=WithDisabledControl.js.map